import { useContext } from 'react';

import { ModalContext } from '@/components/providers/ModalProvider';

export const useModal = () => useContext(ModalContext);
